import axios, { InternalAxiosRequestConfig } from 'axios'
import { RootState } from './redux/store'

export const apiBaseURL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000'

export interface CustomAxiosRequestConfig extends InternalAxiosRequestConfig {
  useRefreshToken?: boolean
}

const $api = axios.create({
  withCredentials: true,
  baseURL: `${apiBaseURL}`,
})

export const setupInterceptors = (store: typeof import('./redux/store').store) => {
  $api.interceptors.request.use((config: CustomAxiosRequestConfig) => {
    const state = store.getState() as RootState
    const token = config.useRefreshToken ? state.auth.refreshToken : state.auth.token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  })

  $api.interceptors.response.use(
    (response) => {
      return response
    },
    (error) => {
      if (!error.config?.__isRetryRequest) {
        console.error('API Error:', error.response?.data?.message || error.message)
      }

      console.error('error:', error)
      const message = error.response?.data?.message
      if (message) {
        return Promise.reject(new Error(message))
      }

      return Promise.reject(error)
    },
  )
}

export default $api
